import { render, staticRenderFns } from "./TextPage.vue?vue&type=template&id=4c0b3a4a&scoped=true&"
import script from "./TextPage.vue?vue&type=script&lang=js&"
export * from "./TextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b3a4a",
  null
  
)

export default component.exports